











import { Component, Watch, Vue } from 'vue-property-decorator'
import { State, Getter, namespace } from 'vuex-class'
import SurfaceHeader from 'vuecomponents/surface_header.vue'
import SurfaceSections from 'vuecomponents/surface_sections.vue'
import DropToPostMixin from 'vuemixins/drop_to_post_mixin'
import { scrollToSectionId } from 'surface/dom_helpers'
import {
  extractPostAttributesArrayFromClipboardData,
  extractPostAttributesFromClipboardData,
  PasteType,
} from 'bits/clipboard'
import { trackEvent } from 'bits/analytics'

const post = namespace('post')
const section = namespace('section')

@Component({
  components: {
    SurfaceHeader,
    SurfaceSections,
  },
  mixins: [DropToPostMixin],
})
export default class SurfaceContainerShelf extends Vue {
  @State xHeader
  @post.Getter newestPostCid
  @post.Getter postEntitiesByCid
  @post.Action createPost
  @section.Action startEditingSection
  @section.Action deleteSection
  @Getter isPostable

  enableDropToPost!: (wallContainer: Element) => void // from DropToPostMixin
  disableDropToPost!: (wallContainer: Element) => void // from DropToPostMixin

  mounted() {
    this.$nextTick(() => this.toggleNewPostHandlers(this.isPostable))
  }

  beforeDestroy() {
    this.disableNewPostHandlers()
  }

  enableNewPostHandlers() {
    this.enableDropToPost(this.$el)
  }

  disableNewPostHandlers() {
    this.disableDropToPost(this.$el)
  }

  handleOnPaste(event: ClipboardEvent): void {
    if (!this.isPostable) return

    const data = extractPostAttributesArrayFromClipboardData(event.clipboardData)
    if (!data || !data.length) return

    // Create a post with attachment without filename
    // when PasteType is File
    const attachment = extractPostAttributesFromClipboardData(data, PasteType.File)
    if (attachment) {
      this.createPost({ attributes: attachment.postAttributes })
      trackEvent('Posts', 'add', `Paste ${attachment.pasteType}`)
      return
    }

    // Create a new post when PasteType is Link or Text or PostContentHash
    this.createPost({ attributes: data[0].postAttributes })
    trackEvent('Posts', 'add', `Paste ${data[0].pasteType}`)
  }

  @Watch('isPostable')
  toggleNewPostHandlers(newValue) {
    newValue ? this.enableNewPostHandlers() : this.disableNewPostHandlers()
  }

  @Watch('newestPostCid')
  scrollWallToSection(postCid): void {
    const sectionId = this.postEntitiesByCid[postCid].wall_section_id
    scrollToSectionId(sectionId)
  }
}
